import AxiosInstance from "./api";

export const BillService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/bill", {
      params: query,
    });
  },
  getById: async (id) => {
    return await AxiosInstance.get(`/private/bill/${id}`);
  },
  create: async (payload) => {
    return await AxiosInstance.post("/admin/bill", payload);
  },
  update: async (id, payload) => {
    return await AxiosInstance.patch("/admin/bill/" + id, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete("/admin/bill/" + id);
  },
};
